export default {
  MENUS: [
    {
      title: 'Dashboard',
      name: 'Home',
      type: 'home',
      icon: 'fas fa-tachometer-alt',
      show: false
    },
    {
      title: 'Đất nước',
      view: 'shared',
      name: 'Country',
      type: 'country',
      icon: 'fas fa-globe',
      index: {
        titles: [{ label: 'ĐẤT NƯỚC', value: 'country' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['edit', 'detail', 'delete'],
        headerActions: ['add', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'vrtour', 'country_content', 'vehicle_info', 'local_cuisine', 'travel_experience', 'festival_info', 'fun_facts'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'address',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'area',
        'dashboard',
        'kiosk',
        'lookup',
        'attraction',
        'museum',
        'event',
        'stay',
        'cuisine',
        'entertainment',
        'company',
        'health',
        'real-estate',
        'government-agency',
        'financial',
        'golf',
        'restaurant',
        'other',
        'tour',
        'campaign'
      ]
    },
    {
      title: 'Khu vực',
      view: 'shared',
      name: 'Area',
      type: 'area',
      icon: 'fas fa-city',
      index: {
        titles: [{ label: 'KHU VỰC', value: 'area' }],
        columns: ['stt', 'avatar', 'name', 'country', 'created_at', 'language', 'actions'],
        actions: ['edit', 'detail', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'vrtour', 'area_content', 'vehicle_info', 'local_cuisine', 'travel_experience'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'address',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'dashboard',
        'kiosk',
        'lookup',
        'attraction',
        'museum',
        'event',
        'stay',
        'cuisine',
        'entertainment',
        'company',
        'health',
        'real-estate',
        'government-agency',
        'financial',
        'golf',
        'restaurant',
        'other',
        'tour',
        'campaign'
      ]
    },
    {
      title: 'Trang chủ',
      view: 'shared',
      name: 'Dashboard',
      type: 'dashboard',
      icon: 'fas fa-home',
      index: {
        titles: [{ label: 'TRANG CHỦ', value: 'dashboard' }],
        columns: ['stt', 'avatar', 'name', 'country', 'created_at', 'language', 'actions'],
        actions: ['edit', 'detail', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'vrtour', 'description', 'content'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'address',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'kiosk',
        'lookup',
        'museum',
        'lookup'
      ]
    },
    {
      title: 'Không gian văn hóa',
      view: 'shared',
      name: 'Museum',
      type: 'museum',
      icon: 'fas fa-mosque',
      index: {
        titles: [{ label: 'KHÔNG GIAN VĂN HÓA', value: 'museum' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'created_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'edit', 'detail', 'related', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'packages',
          'place_parent',
          'display',
          'display_model',
          'structure',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'kiosk',
        'museum',
        'lookup',
        'event',
        'tour',
        'post',
        'campaign'
      ],
      related: [
        'museum',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Tài liệu',
      view: 'shared',
      name: 'Document',
      type: 'document',
      icon: 'fas fa-file',
      index: {
        titles: [{ label: 'TÀI LIỆU', value: 'document' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'created_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'edit', 'detail', 'related', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'packages',
          'place_parent',
          'display',
          'display_model',
          'structure',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'kiosk',
        'document',
        'lookup',
        'event',
        'tour',
        'post',
        'campaign'
      ],
      related: [
        'document',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Âm nhạc',
      view: 'shared',
      name: 'Music',
      type: 'music',
      icon: 'fas fa-music',
      index: {
        titles: [{ label: 'ÂM NHẠC', value: 'music' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'created_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'edit', 'detail', 'related', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'packages',
          'place_parent',
          'display',
          'display_model',
          'structure',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'kiosk',
        'music',
        'lookup',
        'event',
        'tour',
        'post',
        'campaign'
      ],
      related: [
        'music',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Hình ảnh',
      view: 'shared',
      name: 'Image',
      type: 'image',
      icon: 'fas fa-image',
      index: {
        titles: [{ label: 'HÌNH ẢNH', value: 'image' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'created_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'edit', 'detail', 'related', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'packages',
          'place_parent',
          'display',
          'display_model',
          'structure',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'kiosk',
        'image',
        'lookup',
        'event',
        'tour',
        'post',
        'campaign'
      ],
      related: [
        'image',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Video',
      view: 'shared',
      name: 'Video',
      type: 'video',
      icon: 'fas fa-video',
      index: {
        titles: [{ label: 'VIDEO', value: 'image' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'created_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'edit', 'detail', 'related', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'packages',
          'place_parent',
          'display',
          'display_model',
          'structure',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'kiosk',
        'video',
        'lookup',
        'event',
        'tour',
        'post',
        'campaign'
      ],
      related: [
        'video',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Tin tức',
      view: 'shared',
      name: 'News',
      type: 'news',
      icon: 'fas fa-newspaper',
      index: {
        titles: [{ label: 'TIN TỨC', value: 'news' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'created_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'edit', 'detail', 'related', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'packages',
          'place_parent',
          'display',
          'display_model',
          'structure',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'kiosk',
        'news',
        'lookup',
        'event',
        'tour',
        'post',
        'campaign'
      ],
      related: [
        'news',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Nhân vật',
      view: 'shared',
      name: 'People',
      type: 'people',
      icon: 'fas fa-user',
      index: {
        titles: [{ label: 'Nhân vật', value: 'people' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'created_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'edit', 'detail', 'related', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'packages',
          'place_parent',
          'display',
          'structure',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'kiosk',
        'museum',
        'lookup',
        'event',
        'tour',
        'post',
        'campaign'
      ],
      related: [
        'museum',
        'attraction',
        'event'
      ]
    },
    {
      title: 'Kiosk',
      view: 'shared',
      name: 'Kiosk',
      type: 'kiosk',
      icon: 'fas fa-tablet-alt',
      index: {
        titles: [{ label: 'KIOSK', value: 'kiosk' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['edit', 'detail', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'vrtour', 'description', 'content'],
        leftCards: ['artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'place_parent',
          'display',
          'structure',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'lookup'
      ]
    },
    {
      title: 'Tra cứu',
      view: 'shared',
      name: 'Lookup',
      type: 'lookup',
      icon: 'fas fa-filter',
      index: {
        titles: [{ label: 'TRA CỨU', value: 'lookup' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['edit', 'detail', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'vrtour', 'description', 'content'],
        leftCards: ['artifacts', 'artifact_groups', 'groups', 'background'],
        rightCards: [
          'place_parent',
          'display',
          'structure',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'lookup'
      ]
    },
    {
      title: 'Danh thắng',
      view: 'shared',
      name: 'Attraction',
      type: 'attraction',
      icon: 'fas fa-place-of-worship',
      index: {
        titles: [{ label: 'DANH THẮNG', value: 'attraction' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'created_at', 'language', 'actions'],
        actions: ['copy', 'showQR', 'edit', 'detail', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'packages',
          'place_parent',
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      },
      detail: [
        'attraction',
        'tour',
        'post',
        'campaign'
      ]
    },
    {
      title: 'Sự kiện',
      view: 'shared',
      name: 'Event',
      type: 'event',
      icon: 'fas fa-calendar-week',
      index: {
        titles: [{ label: 'Sự kiện', value: 'event' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'packages',
          'place_parent',
          'display',
          'price',
          'times',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Chỗ ở',
      view: 'shared',
      name: 'Stay',
      type: 'stay',
      icon: 'fas fa-bed',
      index: {
        titles: [{ label: 'CHỖ Ở', value: 'stay' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['facility', 'services', 'groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Ăn uống',
      view: 'shared',
      name: 'Cuisine',
      type: 'cuisine',
      icon: 'fas fa-utensils',
      index: {
        titles: [{ label: 'ĂN UỐNG', value: 'cuisine' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['services', 'groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Giải trí',
      view: 'shared',
      name: 'Entertainment',
      type: 'entertainment',
      icon: 'fas fa-play-circle',
      index: {
        titles: [{ label: 'GIẢI TRÍ', value: 'entertainment' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content', 'route_map'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Doanh nghiệp',
      view: 'shared',
      name: 'Company',
      type: 'company',
      icon: 'fas fa-building',
      index: {
        titles: [{ label: 'DOANH NGHIỆP', value: 'company' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Chăm sóc sức khỏe',
      view: 'shared',
      name: 'Health',
      type: 'health',
      icon: 'fas fa-heart',
      index: {
        titles: [{ label: 'CHĂM SÓC SỨC KHỎE', value: 'health' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Bất động sản',
      view: 'shared',
      name: 'Real-estate',
      type: 'real-estate',
      icon: 'fas fa-landmark',
      index: {
        titles: [{ label: 'BẤT ĐỘNG SẢN', value: 'real-estate' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Cơ quan nhà nước',
      view: 'shared',
      name: 'Government-agency',
      type: 'government-agency',
      icon: 'fas fa-building',
      index: {
        titles: [{ label: 'CƠ QUAN NHÀ NƯỚC', value: 'government-agency' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Tài chính',
      view: 'shared',
      name: 'Financial',
      type: 'financial',
      icon: 'fas fa-dollar-sign',
      index: {
        titles: [{ label: 'TÀI CHÍNH', value: 'financial' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Golf',
      view: 'shared',
      name: 'Golf',
      type: 'golf',
      icon: 'fas fa-golf-ball',
      index: {
        titles: [{ label: 'GOLF', value: 'golf' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Nhà hàng',
      view: 'shared',
      name: 'Restaurant',
      type: 'restaurant',
      icon: 'fas fa-concierge-bell',
      index: {
        titles: [{ label: 'NHÀ HÀNG', value: 'restaurant' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize', 'cook', 'cashier', 'tag']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['facility', 'services', 'groups', 'foods', 'food_groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Dịch vụ khác',
      view: 'shared',
      name: 'Other',
      type: 'other',
      icon: 'fas fa-align-justify',
      index: {
        titles: [{ label: 'DỊCH VỤ KHÁC', value: 'other' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['showQR', 'edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'ordered', 'qr_code', 'vrtour', 'description', 'content'],
        leftCards: ['groups'],
        rightCards: [
          'display',
          'price',
          'days',
          'hours',
          'address',
          'contact',
          'category',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Bài viết',
      view: 'shared',
      name: 'Post',
      type: 'post',
      icon: 'fas fa-file',
      index: {
        titles: [{ label: 'BÀI VIẾT', value: 'post' }],
        columns: ['stt', 'avatar', 'name', 'parent', 'created_at', 'language', 'actions'],
        actions: ['edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['name', 'qr_code', 'ordered', 'vrtour', 'vrtour_trailer', 'description', 'content', 'navigation', 'route_map'],
        leftCards: ['artifacts', 'artifact_groups', 'groups'],
        rightCards: [
          'display',
          'display_model',
          'category',
          'place',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Tour course',
      view: 'shared',
      name: 'Tour',
      type: 'tour',
      icon: 'fab fa-foursquare',
      index: {
        titles: [{ label: 'TOUR COURSE', value: 'tour' }],
        columns: ['stt', 'avatar', 'name', 'created_at', 'language', 'actions'],
        actions: ['edit', 'delete'],
        headerActions: ['add', 'filter', 'reset', 'synchronize']
      },
      show: {
        inputs: ['t_name', 'price', 'distance', 'description', 'content', 'agent_info', 'policy', 'tip_hour'],
        leftCards: ['schedule', 'groups'],
        rightCards: [
          'packages',
          'display',
          'address',
          'contact',
          'category',
          'place',
          'youtube',
          'audios',
          'pictures',
          'videos'
        ]
      }
    },
    {
      title: 'Danh mục',
      name: 'Category',
      type: 'category',
      icon: 'fas fa-folder',
      show: false
    },
    {
      title: 'Campaign',
      view: 'shared',
      name: 'Campaign',
      type: 'campaign',
      icon: 'fab fa-cuttlefish',
      index: {
        titles: [{ label: 'POPUP', value: 'popup' }, { label: 'NOTIFICATION', value: 'notification' }],
        columns: ['stt', 'cam_avatar', 'cam_name', 'cam_times', 'created_at', 'language', 'actions'],
        actions: ['edit', 'delete'],
        headerActions: ['add', 'reset', 'synchronize']
      },
      show: {
        inputs: ['cam_name', 'description', 'content', 'cam_link'],
        leftCards: ['banner'],
        rightCards: [
          'cam_display',
          'cam_type',
          'dates',
          'status',
          'place',
          'address'
        ]
      }
    },
    {
      title: 'Bình luận',
      view: 'shared',
      name: 'Comment',
      type: 'comment',
      icon: 'fas fa-comment',
      index: {
        titles: [{ label: 'BÌNH LUẬN ĐÃ DUYỆT', value: 'true' }, { label: 'BÌNH LUẬN CHƯA DUYỆT', value: 'false' }],
        columns: ['stt', 'c_object', 'c_creator', 'content', 'c_approved', 'c_created_at', 'actions'],
        actions: ['browser', 'unbrowser', 'delete'],
        headerActions: ['reset', 'export']
      }
    },
    {
      title: 'Package',
      name: 'Package',
      type: 'package',
      icon: 'fas fa-box',
      show: false
    },
    {
      title: 'Trang Banner',
      name: 'Pages',
      type: 'pages',
      icon: 'fas fa-ad',
      show: false
    },
    {
      title: 'Tổ chức',
      name: 'Organizations',
      type: 'organizations',
      icon: 'fas fa-sitemap',
      show: true
    },
    {
      title: 'Quản trị viên',
      name: 'Staff',
      type: 'staff',
      icon: 'fas fa-id-badge',
      show: false
    },
    {
      title: 'Người dùng',
      name: 'User',
      type: 'user',
      icon: 'fas fa-users',
      show: false
    }
  ]
}
